// import * as types from '../mutation-types'
// import prService from '../api/services/pr'

import tscService from "../api/services/tscService"


const state = { // คล้าย data
  name: '',
  customers: { data: [] },
  history: { data: [] },
  quoDTItems: [],
}
// call state
// this.#store.state.[filename].name
// this.#store.state.prDoc.name


const mutations = { // คล้าย property
  setName(state, payload) {
    state.name = payload.name
  },
  setCustomer(state, payload) {
    // console.log('before',state.history)
    state.customers = payload
    // console.log('after',state.history)
  },
  setHistory(state, payload) {
    // console.log('before',state.history)
    state.history = payload
    // console.log('after',state.history)
  },
  setQuoDTItems(state, payload) {
    // console.log('before',state.history)
    state.quoDTItems = payload
    // console.log('after',state.history)
  }
}
// call mutations
// this.$store.commit('setCustomer',{name:'pom'})
// this.$store.commit('[mutationName]',{name:'pom'})
// this.$store.commit('setName',{name:'pom'})

const actions = { // ก็เหมือน Methods แต่จะต่างตรงที่ จะเรียก mutations แบบ async
  actionName({ commit }, playload) {
    commit('setName', playload)
  },
  quoDTCopy({ commit }, playload) {
    localStorage.setItem('quoDTClipboard', JSON.stringify(playload))
    commit('setQuoDTItems', playload)
  },
  tscLoadHistory({ commit, rootState }) {
    if (localStorage.getItem('tscQDTHistory')) {
      let payload = JSON.parse(localStorage.getItem('tscQDTHistory'))
      commit('setHistory', payload)
      return
    }
    let sortBy = 'CustomName'
    // if(search==="***"){
    //   sortBy = 'CustomerInsertDate desc'
    // }
    //let payload =
    tscService.quotationdtListByParam({
      pageNo: 1,
      rowsPerPage: -1,
      sortBy: sortBy,
      descending: '',
      search: '',
      History: 'Y'
    }).then((payload) => {
      commit('setHistory', payload.data)
      localStorage.setItem('tscQDTHistory', JSON.stringify(payload.data))
    })
  },
  async LoadCustomers({ commit, rootState }, search) {
    // let local_customer = []
    // if (localStorage.getItem('tsc_Customers')){
    //   local_customer = JSON.parse(localStorage.getItem('tsc_Customers'))
    // } 
    let sortBy = ''
    if (search === "***") {
      sortBy = 'CustomerInsertDate desc'
    }
    let payload = await tscService.customerListByParam({
      pageNo: 1,
      rowsPerPage: 50,
      sortBy: sortBy,
      descending: '',
      search: search,
    })
    // if (local_customer.length !== payload.data.data.length ) {
    // payload = await tscService.customerListByParam({
    //             pageNo: 1,
    //             rowsPerPage: 20,
    //             sortBy: 'CustomerName',
    //             descending: '',
    //             search: '',
    //           })
    // localStorage.setItem('tsc_Customers',JSON.stringify(payload.data.data))
    // } else {
    // payload = local_customer
    // }
    commit('setCustomer', payload.data)

    // console.log(payload.data)

  },

}
// call actions
// this.$store.dispatch('[actionName]')
// this.$store.dispatch('LoadCustomers')
// this.$store.dispatch('tscLoadHistory')
// this.$store.dispatch('quoDTCopy')


const getters = { // คล้าย Compute
  customers(state) {
    return state.customers.data
    // .map(obj => {
    //   const hasValue = val => val != null ? val : ''
    //   obj.itemText = hasValue(obj.Item) + hasValue(obj.Qty.toString()) + hasValue(obj.price.toString()) + hasValue(obj.unit) + hasValue(obj.itemSpac)
    //   return obj
    // })
  },
  quoDTClipboard(state) {
    return state.quoDTItems
    // .map(obj => {
    //   const hasValue = val => val != null ? val : ''
    //   obj.itemText = hasValue(obj.Item) + hasValue(obj.Qty.toString()) + hasValue(obj.price.toString()) + hasValue(obj.unit) + hasValue(obj.itemSpac)
    //   return obj
    // })
  },
  tscQhistory(state) {
    return state.history.data
      .sort((a, b) => {
        if (a.CustomName < b.CustomName) {
          return -1;
        }
        if (a.CustomName > b.CustomName) {
          return 1;
        }
        return 0;
      }).map(obj => {
        const hasValue = val => val != null ? val : ''
        obj.itemText = hasValue(obj.CustomName) + ' | (฿' + hasValue(obj.ServicePrice) + ') | ' + hasValue(obj.CustomUnit)
        return obj
      })
    // .map(obj => {
    //   const hasValue = val => val != null ? val : ''
    //   obj.itemText = hasValue(obj.Item) + hasValue(obj.Qty.toString()) + hasValue(obj.price.toString()) + hasValue(obj.unit) + hasValue(obj.itemSpac)
    //   return obj
    // })
  },
}
//call getters  this.$store.getters.[getterName]
// this.$store.getters.nameLen
// this.$store.getters.nameLen
// this.$store.getters.quoDTClipboard


export default {
  state,
  mutations,
  getters,
  actions
}